import IconButton from "../../../components/IconButton";
import { IconEye, IconSwitch } from "../../../icons";
import { convertDate } from "../../../libs/dateUtils";
import useHistoryStore from "../store/useStore";

export function TableContent() {
  const { handleOrderListByTH, listGroupedHistory, page, selectSize } = useHistoryStore();
  const { setNeedModal } = useHistoryStore();

  function listRenderObserverThePage(indexOfLine: number) {
    const initialListRender = indexOfLine < (page + 1) * selectSize;
    const endListRender = indexOfLine >= page * selectSize;
    return initialListRender && endListRender;
  }

  return (
    <>
      <thead>
        <tr>
          <th>
            <div className="wrapperTheader">
              Data
              <IconButton icon={IconSwitch} onClick={() => handleOrderListByTH("created_at")} />
            </div>
          </th>
          <th>
            <div className="wrapperTheader">
              <span>Nome</span>
              <IconButton className="center row-trash icon-trash" icon={IconSwitch} onClick={() => handleOrderListByTH("json_now", "name")} />
            </div>
          </th>
          <th>Ver mais</th>
        </tr>
      </thead>
      <tbody className="tbody-history">
      {listGroupedHistory?.map((data: any, index: number) => {
        return (
            listRenderObserverThePage(index) && (
            <tr>
              <td className="tdName">
                <span className="">{convertDate(data?.created_at)}</span>
              </td>
              <td className="tdName">
                <span className="">{data?.json_now.name}</span>
              </td>
              <td className="tdName col-function row-edit">
                <span className="center">
                  {" "}
                  <IconButton onClick={() => setNeedModal(data?.user_id)} icon={IconEye} />{" "}
                </span>
              </td>
            </tr>
            )
            );
          })
        }
        </tbody>
    </>
  );
}
